export default __webpack_public_path__ + "static/media/210430-Cloudxier Clients Logo-01.5ba90c40.png";